







import CommonBase from "./CommonBase";
import {Component, Prop} from "vue-property-decorator";
import DateInput from "./DateInput.vue";
import {DateTime} from "../modules/models";

@Component({
    components: {
        "at-date-input": DateInput
    }
})
export default class BirthDateInput extends CommonBase {
    @Prop({default: null})
    value!: DateTime | null;
    @Prop({default: false})
    solo!: boolean;
    @Prop({default: false})
    flat!: boolean;
    @Prop({default: false})
    required!: boolean;
    @Prop({default: "Fødselsdato"})
    label!: string;


    minBdate!: DateTime;
    maxBdate!: DateTime;

    get birthDate() {
        return this.value;
    }
    set birthDate(v: DateTime | null) {
        this.$emit("input", v);
    }

    created() {
        const now = DateTime.now();
        this.minBdate = now.withYear(now.year() - 110);
        this.maxBdate = now.withYear(now.year() - 2);
    }
}
